import { BarceloComponent } from "components-utils";

const AdvComponents = {
  ribbon: BarceloComponent({ selector: ".c-ribbon", path: "barcelo/adv/ribbon/js/c-ribbon" }),
  languageRibbon: BarceloComponent({
    selector: ".ribbon-language",
    path: "barcelo/adv/ribbon-language/js/c-ribbon-language",
    belongsTo: "ribbon",
    customName: "language",
  }),
  translationEnabledLanguageDialog: BarceloComponent({ selector: ".translation-enabled-language-dialog-JS", path: "barcelo/adv/translation-enabled-language-dialog/js/translation-enabled-language-dialog" }),
};

export default AdvComponents;
